export default class Template {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    getList() {
        return this.rest.one('template').get();
    };

    get(id) {
        return this.rest.one('template', id).get();
    };

    getHtmlContent(templateId) {
        return this.rest.one('template', templateId).one('htmlContent').get();
    };
    
    getPlainContent(templateId) {
        return this.rest.one('template', templateId).one('plainContent').get();
    };

    delete(id) {
        return this.rest.one('template', id).remove();
    };

    store(template) {
        return this.rest.all('template').post({
            name: template.name,
            plain: template.plain,
            html: template.html,
            typeId: template.typeId
        });
    };

    update(template) {
        return this.rest.one('template/' + template.id).customPUT({
             name: template.name,
            plain: template.plain,
            html: template.html,
            typeId: template.typeId
        });
    };

    uploadThumbnail(templateId, file, original) {
        let thumbnailFile = new FormData();
        original = (original != null) ? original : false;
        thumbnailFile.append('thumbnail', file);

        return this.rest.one('template/' + templateId + '/update-thumbnail')
            .withHttpConfig({transformRequest: angular.identity})
            .customPOST(
                thumbnailFile,
                '',
                { original: original },
                { 'Content-Type': undefined }
            );
    };

    updateImage(templateId, imageId, typeId) {
        return this.rest.all('template/' + templateId + '/update-image').post({
            image_id: imageId,
            image_type_id: typeId
        });
    };

    getDefaultHtmlContent() {
        return this.rest.one('views/template/default/default.html').get();
    };

    uploadOrder(file, contactEmail) {
        var orderForm = new FormData();
        orderForm.append(file.name, file);
        orderForm.append('contactEmail', contactEmail);

        return this.rest.one('template/order-upload')
            .withHttpConfig({ transformRequest: angular.identity })
            .customPOST(
                orderForm,
                '',
                {},
                {'Content-Type': undefined }
            );
    };
    
    findAllTypes() {
        return this.rest.one('template').one('types').one('findAll').get();
    };

    allTypesByLanguage() {
        return this.rest.one('template').one('types').one('allTypesByLanguage').get();
    };
    
    allByType(typeId) {
        return this.rest.one('template', typeId).one('allByType').get();
    };
};
